/* Cloudfolk Goods: personalization field helpers (live preview, friendly validation messages). */
(function () {
  if (window.__cfPersonalize) return;
  window.__cfPersonalize = true;

  function isField(el) {
    return el && el.matches && el.matches('[data-cf-personalize]');
  }

  function update(input) {
    var wrap = input.closest('.cf-personalize');
    if (!wrap) return;
    var preview = wrap.querySelector('[data-cf-preview]');
    var count = wrap.querySelector('[data-cf-count]');
    var value = input.value;
    if (preview) preview.textContent = value.trim() ? value.toUpperCase() : (input.placeholder || '').toUpperCase();
    if (count) count.textContent = String(value.length);
    wrap.classList.toggle('is-filled', value.trim().length > 0);
  }

  function setMessage(input) {
    input.setCustomValidity('');
    if (input.validity.valueMissing || (input.value && !input.value.trim())) {
      input.setCustomValidity(input.dataset.msgMissing || 'Type the name you would like printed.');
    } else if (input.validity.patternMismatch) {
      input.setCustomValidity(input.dataset.msgPattern || 'Use letters, numbers, spaces and \' - . & only.');
    }
  }

  document.addEventListener('input', function (e) {
    if (!isField(e.target)) return;
    var input = e.target;
    input.classList.remove('is-invalid');
    setMessage(input);
    update(input);
  });

  document.addEventListener(
    'invalid',
    function (e) {
      if (!isField(e.target)) return;
      setMessage(e.target);
      e.target.classList.add('is-invalid');
    },
    true
  );

  /* Run custom messages before the browser validates on Add to cart. */
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('button[type="submit"], button[name="add"]');
      if (!btn || !btn.form) return;
      var fields = document.querySelectorAll('[data-cf-personalize][form="' + btn.form.id + '"]');
      fields.forEach(setMessage);
    },
    true
  );

  function init() {
    document.querySelectorAll('[data-cf-personalize]').forEach(function (input) {
      setMessage(input);
      update(input);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
